// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7618":"107ba0d8b61ece87","92888":"456625497ff92904"}[chunkId] + ".css";
};